import React from 'react'
import { IcaCardRow } from '../IcaElements/IcaCardRow'
import { IcaCheckbox } from '../IcaElements/IcaCheckbox'
import { Store } from '../../contexts/store-context'
import { IcaSelectDropDown } from '../IcaElements/IcaSelectDropDown'

interface ISiteSelectorProps {
  sites: Store[]
  selectedSites: string[]
  allSitesSelected: boolean
  handleSiteSelection: (siteId: string) => void
  handleSelectAllSites: () => void
}

export default function SiteSelector({ sites, selectedSites, handleSiteSelection, allSitesSelected, handleSelectAllSites }: ISiteSelectorProps) {
  return (
    <div className={`px-4 pb-5 flex flex-col gap-3 ${sites.length ? 'border-b border-[#EDEDED] ': ''}`}>
      <p className='font-bold mt-2'>Dina siter</p>
      <IcaSelectDropDown
        label={`${selectedSites.length} ${selectedSites.length === 1 ? 'vald' : 'valda'}`}
        multiple
      >
        <IcaCardRow
          key={'option-select-all'}
          noninteractive
        >
          <IcaCheckbox
            label='Välj alla'
            checked={allSitesSelected}
            onChange={handleSelectAllSites}
          />
        </IcaCardRow>
        {sites.map((site) => (
          <IcaCardRow
            key={`option-${site.id}`}
            noninteractive
          >
            <IcaCheckbox
              label={site.name}
              checked={selectedSites.includes(site.id)}
              onChange={() => handleSiteSelection(site.id)}
            />
          </IcaCardRow>
        ))}
      </IcaSelectDropDown>
    </div>
  )
}
